import Vue from 'vue'
import store from '@/store'

export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

export function isAuth (key) {
  return true
  // return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

export function treeDataTranslate (data, id = 'id', pid = 'parentId') {
  let res = []
  let temp = {}
  for (let d of data) {
    temp[d[id]] = d
  }
  for (let d of data) {
    if (temp[d[pid]] && d[id] !== d[pid]) {
      if (!temp[d[pid]]['children']) {
        temp[d[pid]]['children'] = []
      }
      if (!temp[d[pid]]['_level']) {
        temp[d[pid]]['_level'] = 1
      }
      d['_level'] = temp[d[pid]]._level + 1
      temp[d[pid]]['children'].push(d)
    } else {
      res.push(d)
    }
  }
  return res
}

export function clearLoginInfo () {
  store.commit('resetStore')
  Vue.cookie.delete('token')
  Vue.cookie.delete('userName')
  sessionStorage.removeItem('menuList')
  sessionStorage.removeItem('dynamicMenuRoutes')
}



// WEBPACK FOOTER //
// ./src/utils/index.js